import StudentsModule from '@features/Student/Students.Module';

const StudentsReg = () => {
  return <StudentsModule />;
};

export default StudentsReg;
